import { Email, Message, Opacity, Person, Send } from '@mui/icons-material'
import { Box, Button, Grid, InputAdornment, Paper, TextField, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import {motion} from 'framer-motion';

function Contact() {
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const inputStyle = {
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
            borderColor: 'primary',
            },
        },
        '& .MuiInputLabel-root': {
            color: 'primary',
        },
    }
  return (
    <Box component={"div"} id='contact' py={5}>
        <Typography variant='h3' sx={{ fontWeight: "700" }} textAlign="center" width={300} borderBottom="1px solid" borderColor={"primary"} color="primary" m="auto" mb={5}>Contact Me</Typography>
        <Grid container component={"div"} justifyContent={"center"} sx={{ paddingX: isSmallScreen ? "8px" : "40px" }}>
            <Grid item lg={4} sm={12}>
            <motion.div
                initial={{
                    scale: 0
                }}
                whileInView={{
                    scale: 1
                }}
                transition={{
                    duration: 1,
                    ease: "easeInOut",
                   
                }}  
            >
                <lottie-player src="https://lottie.host/4c3e1cc5-a3bd-4399-9676-d70b037a3bdf/iiYewHg8ks.json" background="#FFFFFF" speed="1" style={{width: "300px", height: "300px"}} loop autoplay direction="1" mode="normal"></lottie-player>
            </motion.div>
            </Grid>
            <Grid item lg={6} sm={12}>
                <Paper elevation={2} sx={{padding: "20px"}}>
                    <Box component={"form"}>
                    <TextField
                        type='text'
                        label="Name"
                        size="small"
                        fullWidth
                        InputProps={{
                            'startAdornment': (
                                <InputAdornment position='start'>
                                    <Person color='primary' />
                                </InputAdornment>
                            )
                        }}
                        required
                        margin='normal'
                        sx={inputStyle}
                    />
                    <TextField
                        type='email'
                        label="Email"
                        size="small"
                        fullWidth
                        InputProps={{
                            'startAdornment': (
                                <InputAdornment position='start'>
                                    <Email color='primary' />
                                </InputAdornment>
                            )
                        }}
                        required
                        margin='normal'
                        sx={inputStyle}
                    />
                    <TextField
                        type='text'
                        label="Message"
                        size="small"
                        fullWidth
                        InputProps={{
                            'startAdornment': (
                                <InputAdornment position='start'>
                                    <Message color='primary' />
                                </InputAdornment>
                            )
                        }}
                        required
                        margin='normal'
                        multiline
                        rows={4}
                        sx={inputStyle}
                    />
                    <Button
                        type='submit'
                        variant="outlined" 
                     endIcon={<Send color='primary' />}
                        sx={{
                            marginTop: "10px",
                            borderColor: "#6d70a5",
                            color: "primary",
                            '&:hover': {
                                borderColor: "#42446E",
                                color: "#42446E",
                            }
                        }}
                    >
                        Send
                    </Button>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    </Box>
  )
}

export default Contact